import IframeAdjustments from './IframeAdjustments';

export default IframeAdjustments;
